<template>
	<div class="container-fluid no-padding-sides">
		<div id="myCarousel" class="carousel slide" data-ride="carousel">
			<!-- Wrapper for slides -->
			<div class="carousel-inner" role="listbox">
				<div class="item project-img" v-for="slider in render_sliders" :class="{ 'active': slider.active }" :style="`background-image: url(${ slider.route })`">
					<!-- <img class="img-responsive" src="../../images/projects-contract1.png" alt="slider1"> -->
				</div>
			</div>

			<!-- Left and right controls -->
			<span class="left carousel-control" href="#myCarousel" role="button" data-slide="prev">
				<img class="img-responsive chevron-left" src="../../images/chevron-left-black.png" alt="">
				<span class="sr-only"></span>
			</span>
			<span class="right carousel-control" href="#myCarousel" role="button" data-slide="next">
				<img class="img-responsive chevron-right" src="../../images/chevron-right-black.png" alt="">
				<span class="sr-only"></span>
			</span>
		</div>
	</div>
</template>

<script>
export default {
	// ---- PROPS ----

	props: ['sliders'],

	// ---- RENDER ----

	computed: {
		render_sliders () {
			if (this.sliders) {
				this.sliders[0].active = true;
			}

			return this.sliders;
		}
	}
}
</script>

<style scoped>
	.container-fluid{
		width: 70%;
		margin-top: 40px;
	}
	.carousel-control{
		width: 10%;
	}
	.project-img {
		background-position: center;
		background-repeat: no-repeat;
		background-size: cover;
		height: 300px;
	}
	@media  (min-width: 768px){
		.container-fluid{
			float: right;
		}
	}
</style>


// WEBPACK FOOTER //
// Carousel.vue?56323870